import React from "react";

/**
 * A titled panel for one group of admin settings.
 *
 * Admin tabs had been building this shape by hand in every file, which is why
 * headings and spacing drifted apart. `action` renders on the right of the
 * header (a toggle, a count, a collapse button).
 */
const AdminSectionCard = ({
  icon: Icon,
  title,
  description,
  action,
  disabled = false,
  // Cards nested inside another card read better flat: stacked drop shadows
  // pile into a muddy edge. `elevated={false}` swaps the shadow for a border.
  elevated = true,
  className = "",
  children,
}) => (
  <section
    className={`bg-white rounded-2xl overflow-hidden ${
      elevated ? "shadow-md" : "border border-slate-200"
    } ${disabled ? "opacity-50 pointer-events-none" : ""} ${className}`}
  >
    <div className="px-4 sm:px-6 py-3 sm:py-4 border-b border-slate-200 bg-slate-50/60 flex items-start justify-between gap-3">
      <div className="min-w-0">
        <h3 className="text-sm sm:text-base font-semibold text-slate-900 flex items-center gap-2">
          {Icon && (
            <Icon className="w-4 h-4 sm:w-5 sm:h-5 text-purple-600 flex-shrink-0" />
          )}
          <span>{title}</span>
        </h3>
        {description && (
          <p className="text-xs sm:text-sm text-slate-500 mt-1">{description}</p>
        )}
      </div>
      {action && <div className="flex-shrink-0">{action}</div>}
    </div>
    {children != null && <div className="p-4 sm:p-6">{children}</div>}
  </section>
);

export default AdminSectionCard;
